export const professionalExperience = {
  "en-US": [
    {
      company: "Banco do Brasil S.A.",
      period: "01/2026 - present, hybrid",
      role: "Backend Developer",
      description: [
        "Backend development in Java using Quarkus",
        "Deployment and maintenance of services on Kubernetes and OpenShift",
        "Automation of delivery pipelines with Argo CD, Jenkins, and GitHub Actions",
        "Integration of REST APIs and microservices",
        "Collaborating with agile teams to deliver incremental improvements"
      ],
    },
    {
      company: "Banco do Brasil S.A.",
      period: "03/2022 - 12/2025, hybrid",
      role: "Mobile Developer",
      description: [
        "Mobile development using React Native",
        "Frontend development with Angular and React.js",
        "Figma plugin creation",
        "Working with agile methodologies"
      ],
    },
    {
      company: "Techcom Tecnologia e Informatica Eireli",
      period: "07/2021 - 03/2022, hybrid",
      role: "IT Support Analyst (LNCC Allocation)",
      description: [
        "Installation, configuration, and support of Linux systems and tools used at LNCC",
        "Liaison with Dell international support for OneFS updates on Isilon storage devices"
      ],
    }
  ],

  "pt-BR": [
    {
      company: "Banco do Brasil S.A.",
      period: "01/2026 - atual, híbrido",
      role: "Desenvolvedor Backend",
      description: [
        "Desenvolvimento backend em Java utilizando Quarkus",
        "Implantação e manutenção de serviços em Kubernetes e OpenShift",
        "Automação de pipelines com Argo CD, Jenkins e GitHub Actions",
        "Integração de APIs REST e microsserviços",
        "Colaboração com times ágeis para entregas incrementais"
      ],
    },
    {
      company: "Banco do Brasil S.A.",
      period: "03/2022 - 12/2025, híbrido",
      role: "Desenvolvedor Mobile",
      description: [
        "Desenvolvimento mobile com React Native",
        "Desenvolvimento frontend com Angular e React.js",
        "Criação de plugins para Figma",
        "Atuação com metodologias ágeis"
      ],
    },
    {
      company: "Techcom Tecnologia e Informatica Eireli",
      period: "07/2021 - 03/2022, híbrido",
      role: "Analista de Suporte de TI (Alocação no LNCC)",
      description: [
        "Instalação, configuração e suporte de sistemas Linux e ferramentas utilizadas no LNCC",
        "Intermediação com suporte internacional da Dell para atualizações do OneFS em storages Isilon"
      ],
    }
  ],

  "es-ES": [
  {
    company: "Banco do Brasil S.A.",
    period: "01/2026 - actualidad, híbrido",
    role: "Desarrollador Backend",
    description: [
      "Desarrollo backend en Java utilizando Quarkus",
      "Despliegue y mantenimiento de servicios en Kubernetes y OpenShift",
      "Automatización de pipelines de entrega con Argo CD, Jenkins y GitHub Actions",
      "Integración de APIs REST y microservicios",
      "Colaboración con equipos ágiles para entregar mejoras incrementales"
    ],
  },
  {
    company: "Banco do Brasil S.A.",
    period: "03/2022 - 12/2025, híbrido",
    role: "Desarrollador Mobile",
    description: [
      "Desarrollo mobile con React Native",
      "Desarrollo frontend con Angular y React.js",
      "Creación de plugins para Figma",
      "Trabajo con metodologías ágiles"
    ],
  },
  {
    company: "Techcom Tecnologia e Informatica Eireli",
    period: "07/2021 - 03/2022, híbrido",
    role: "Analista de Soporte de TI (Asignación en LNCC)",
    description: [
      "Instalación, configuración y soporte de sistemas Linux y herramientas utilizadas en LNCC",
      "Interlocución con el soporte internacional de Dell para actualizaciones de OneFS en dispositivos de almacenamiento Isilon"
    ],
  }
],
};
